import { Injectable } from '@angular/core';
import { AngularFireMessaging, } from '@angular/fire/messaging';
import { BehaviorSubject, Subject } from 'rxjs'
import { EventsService } from './events.service';
import * as bulmaToast from 'bulma-toast';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  currentMessage = new BehaviorSubject(null);
  private endpoint = environment.endpoint;
  private url = this.endpoint;
  private devendpoint = environment.cargaendpoint;

  constructor(private angularFireMessaging: AngularFireMessaging, private events: EventsService,
    private httpclient: HttpClient,) {
    this.angularFireMessaging.messaging.subscribe(
      (_messaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      }
    )
  }

  requestPermission() {
    this.angularFireMessaging.requestToken
      .subscribe((token) => {
        // console.log("angularFireMessaging", token);
        localStorage.setItem("deviceToken", JSON.stringify(token))
        if (!localStorage.getItem("USER_INFO")) {
          let deviceInfo
          deviceInfo = {
            deviceName: "Browser",
            deviceToken: token,
            deviceType: "web",
            type: "client", //this.user.type
            username: "", // this.user.username
          }
          // // console.log("deviceInfo 276", deviceInfo);
          localStorage.setItem("deviceInfo", JSON.stringify(deviceInfo))
        }
      },
        (err) => {
          console.error('Unable to get permission to notify.', err);
        }
      );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe((_messaging) => {
      console.log("new message received. ", _messaging["data"]);
      if (_messaging["data"].type !== 'chatAlarm') {
        let msg: any = ""

        if (_messaging["data"].type === 'Announcement') {
          msg = _messaging["data"] ? _messaging["data"].description : ""
        } else {
          msg = _messaging["notification"] ? _messaging["notification"].body : ""
          bulmaToast.toast({
            duration: 6000,
            message: msg,
            type: 'is-success'
          })
        }
      }
      this.currentMessage.next(_messaging);
    })
  }

  getMessage(): Subject<any> {
    return this.currentMessage;
  }

  removeToken() {
    return new Promise(resolve => {
      let token = JSON.parse(localStorage.getItem("deviceToken"))
      // // console.log("deviceToken", token)
      this.angularFireMessaging.deleteToken(token)
        .subscribe(async response => {
          // // console.log("removeToken", response)
          resolve(response)
        })
    })
  }

  renewedToken() {
    return new Promise(resolve => {
      this.angularFireMessaging.requestToken
        .subscribe((token) => {
          // // console.log("angularFireMessaging", token);
          localStorage.setItem("deviceToken", JSON.stringify(token))

          if (!localStorage.getItem("USER_INFO")) {
            let deviceInfo
            deviceInfo = {
              deviceName: "",
              deviceToken: token,
              deviceType: "web",
              type: "", //this.user.type
              username: "", // this.user.username
            }
            // // console.log("deviceInfo 276", deviceInfo);
            localStorage.setItem("deviceInfo", JSON.stringify(deviceInfo))
            resolve(true)
          }
        },
          (err) => {
            console.error('Unable to get permission to notify.', err);
          }
        );
    })
  }

  subscribeToTopic() {
    let topicId = environment.type === 'stg' ? "client-stg" : environment.type === 'dev' ? "client-dev" : "client"
    let params = {
      token: JSON.parse(localStorage.getItem("deviceToken")),
      topic: topicId
    }
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem("authToken"),
      })
    };

    let withoutv1 = environment.type === 'stg' || environment.type === 'prod' ? this.url.split("/v2") : [this.devendpoint]
    // // // console.log("withoutv1", withoutv1)
    const url_format = withoutv1[0]
    const url = url_format + '/v1/custom-ecarga/subscribe'

    this.httpclient.post(url, params, httpOptions)
      .subscribe(async (resp) => {
        console.log("subscribe to topic", resp)
      }, async (err) => {
        console.log("issue subscribing to topic", err)
      })
  }

}
